import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { ShiftCardWrapper } from "@src/appV2/redesign/Shift/Card/Wrapper";
import { SHIFT_DISCOVERY_FAVORITE_WORKPLACES_FULL_PATH } from "@src/appV2/redesign/ShiftDiscovery/paths";
import { useFavoriteWorkplaces } from "@src/appV2/Workplaces/api/useFavoriteWorkplaces";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { useFavoriteWorkplacesOpenShiftsCount } from "../useFavoriteWorkplacesOpenShiftsCount";

export function FavoriteWorkplaceBanner() {
  const history = useHistory();

  const { favoriteWorkplacesCount, isLoading } = useFavoriteWorkplaces();

  const {
    favoriteWorkplacesOpenShiftsCount,
    isLoading: isFavoriteWorkplacesOpenShiftsCountLoading,
  } = useFavoriteWorkplacesOpenShiftsCount();

  if (
    isLoading ||
    isFavoriteWorkplacesOpenShiftsCountLoading ||
    (favoriteWorkplacesCount > 0 && favoriteWorkplacesOpenShiftsCount === 0)
  ) {
    return null;
  }

  const label =
    favoriteWorkplacesCount === 0
      ? "Choose your favorite workplaces to unlock Priority Access and get first choice to their shifts!"
      : "Book at your favorite workplaces now before the shifts are gone!";

  const buttonLabel =
    favoriteWorkplacesCount === 0
      ? "Add favorite workplaces"
      : `See ${favoriteWorkplacesOpenShiftsCount} open ${pluralize(
          "shift",
          favoriteWorkplacesOpenShiftsCount
        )}`;

  return (
    <ShiftCardWrapper
      sx={(theme) => ({
        paddingX: theme.spacing(5),
        paddingY: theme.spacing(4),
        background: theme.palette.favoriteWorkplaces?.background,
        color: theme.palette.text.primary,
      })}
    >
      <Stack justifyContent="center" flex={1} height="100%">
        <Stack alignItems="center" gap={5}>
          <Stack gap={3} alignItems="center">
            <IconButton invert iconType="building" variant="contained" />
            <Text semibold variant="h5" textAlign="center">
              {label}
            </Text>
          </Stack>
          <Button
            invert
            onClick={() => {
              history.push(SHIFT_DISCOVERY_FAVORITE_WORKPLACES_FULL_PATH);
            }}
          >
            {buttonLabel}
          </Button>
        </Stack>
      </Stack>
    </ShiftCardWrapper>
  );
}
